<i18n
  src="@/locales/views/packing_house/quality_control/process/list_harvested_batches.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ph_quality_control_process_list_processes_path"
    :params="{
      packing_house_id: this.packing_house_id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, packing_house_process.name]"
  ></bread-crumbs>

  <h1 class="page-title">
    <i class="fa-solid fa-crate-apple"></i><span class="space-icon"></span>
    {{ $t("labels.title") }}
  </h1>
  <template v-if="render_list">
    <div class="mt-8 flex flex-col">
      <h3 class="">
        {{ $t("labels.total_harvested_batches") }}:
        <b>{{ harvested_batches.length }}</b> -
        {{ $t("labels.total_inspections") }}:
        <b>{{ total_inspections }}</b>
      </h3>

      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.registered_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.batch_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.total_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.ok_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.discarded_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_type") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.total_inspections") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="harvested_batch in harvested_batches"
                  :key="harvested_batch.id"
                >
                  <td class="table-cell">
                    {{ dateFormatter(harvested_batch.registered_at) }}
                  </td>
                  <td
                    class="table-cell-main cursor-pointer"
                    @click="goToListTemplates(harvested_batch)"
                  >
                    {{ harvested_batch.batch_code }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.total_weight }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.ok_weight }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.discarded_weight }}
                  </td>
                  <td class="table-cell">
                    {{ producerLabel(harvested_batch) }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.crop_type.name }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.crop_variety.name }}
                  </td>
                  <td class="table_cell text-center">
                    {{ harvested_batch.total_inspections || "" }}
                  </td>
                  <td class="table-cell-action">
                    <button
                      class="link"
                      @click="goToListTemplates(harvested_batch)"
                    >
                      <i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div />
</template>

<script>
import Requester from "@/views/packing_house/requesters/quality_control/process/list_harvested_batches.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  components: { BreadCrumbs },
  name: "ListHarvestedBatches",
  props: ["packing_house_id", "packing_house_process_id"],
  data() {
    return {
      packing_house_process: {},
      harvested_batches: [],
      exporter_process_quality_templates: [],
      render_list: false,
    };
  },
  computed: {
    total_inspections() {
      return this.harvested_batches.reduce(
        (sum, value) => sum + value.total_inspections,
        0
      );
    },
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.packing_house_process_id
      );
      this.harvested_batches = response.data;
      this.render_list = true;
    },
    fetchExporterQualityTemplates: async function () {
      let response = await Requester.fetchExporterQualityTemplates(
        this.packing_house_process_id
      );
      this.exporter_process_quality_templates = response.data;
    },
    goToListTemplates: function (harvested_batch) {
      this.$router.push({
        name: "ph_quality_control_process_list_templates_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: harvested_batch.id,
        },
      });
    },
    goToTemplateGraph: function (exporter_process_quality_template) {
      this.$router.push({
        name: "ae_quality_control_harvested_batch_harvested_batches_inspect_graphs_path",
        params: {
          packing_house_process_id: this.packing_house_process_id,
          exporter_process_quality_template_id:
            exporter_process_quality_template.id,
        },
      });
    },
    producerLabel: function (harvested_batch) {
      const producer = harvested_batch.producer;
      const organization = harvested_batch.organization;
      if (producer) {
        if (organization) return `${producer.name} (${organization.name})`;

        return producer.name;
      }
      if (organization) return organization.name;

      return "";
    },
  },
  created() {
    this.checkIfAuthenticated();
    this.fetchPackingHouseProcess();
    this.fetchHarvestedBatches();
    // this.fetchExporterQualityTemplates();
  },
};
</script>
